import React, { createContext, useState, useEffect, useContext } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { OktaAuth } from '@okta/okta-auth-js'
import { oktaConfig } from '../Config/OktaConfig'

const oktaAuth = new OktaAuth(oktaConfig)

const UserContext = createContext(null)

export const UserProvider = ({ children }) => {
  const { authState } = useOktaAuth()
  const [user, setUser] = useState(null)

  useEffect(() => {
    const fetchUser = async () => {
      if (authState?.isAuthenticated && !user) {
        const userInfo = await oktaAuth.getUser()
        setUser(userInfo)
      }
    }
    fetchUser()
  }, [authState, user])

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>
}

export const useUser = () => useContext(UserContext)
